import { userLookup } from './user-lookup';

(($) => {
  $(() => {
    const $ageGateModal = $('#age-gate-modal');

    if ($ageGateModal.length) {
      const $ageGateForm = $ageGateModal.find('form');
      const $province = $ageGateForm.find('[name="province"]');
      const $remember = $ageGateForm.find('[name="remember"]');
      const $date = $ageGateForm.find('[name="date"]');
      const $month = $ageGateForm.find('[name="month"]');
      const $year = $ageGateForm.find('[name="year"]');
      const $lockedOutWrapper = $ageGateModal.find('#age-gate-locked-out');
      const $lockedOutMsgAge = $ageGateModal.find('#age-gate-locked-out-age');
      const $lockedOutMsgProvince = $ageGateModal.find('#age-gate-locked-out-province');
      const $ageGateContent = $ageGateModal.find('#age-gate-modal-content');
      const $ageGateBackBtn = $ageGateModal.find('#age-gate-back');

      // START:
      // Utility + validation functions.
      const isUserValid = () => {
        const user = userLookup();
        // If no user's profile exists, the modal will trigger.
        if (!user) {
          return false;
        } else {
          // If user's profile has expired, it's 'invalid' and the modal will trigger.
          if (isStorageExpired(user)) {
            return false;
          }

          // If user is valid, the secondary header modal button will update to show their current province.
          updateAgeGateButton(user);
          updateForm(user);
          return user.isValid;
        }
      };

      const isStorageExpired = (user) => {
        const today = new Date().toISOString();
        // User's profile has an expiry date and it's in the past relative to `today`.
        if (user.expires && user.expires < today) {
          return true;
        }
        // Either user's profile doesn't have expiry date (session storage) or it's in the future relative to `today`.
        return false;
      };

      const calculateAge = (dateString) => {
        const today = new Date();
        const birthDate = new Date(dateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      };

      const getAgeFromForm = ($form) => {
        // ICYMI: Months are zero-based, cf. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date, hence subtracting 1.
        const bdayDateStr = new Date($year.prop('value'), $month.prop('value') - 1, $date.prop('value'));
        const age = calculateAge(bdayDateStr);

        console.log(age);

        return age;
      };

      const approveUser = (age, provinceCode) => {
        let validation = {
          valid: false,
          reason: '',
        };

        if ('qc' === provinceCode) {
          validation.reason = 'province';
          return validation;
        }

        if (('ab' === provinceCode && age >= 18) || age >= 19) {
          validation.valid = true;
        } else {
          validation.reason = 'age';
          return validation;
        }

        return validation;
      };

      const handleSubmit = () => {
        const age = getAgeFromForm($ageGateForm);
        const validationObj = approveUser(age, $province.prop('value'));

        if (validationObj.valid) {
          const user = {
            isValid: validationObj.valid,
            age: age,
            dob: {
              dd: $date.prop('value'),
              mm: $month.prop('value'),
              yy: $year.prop('value'),
            },
            province: $province.prop('value'),
            saved: new Date().toISOString(),
            expires: null,
            remember: false,
          };

          if ($remember.prop('checked')) {
            let expiryDate = new Date();

            expiryDate.setDate(expiryDate.getDate() + 30);

            user.expires = expiryDate;
            user.remember = true;

            localStorage.setItem('user', JSON.stringify(user));
          } else {
            sessionStorage.setItem('user', JSON.stringify(user));
          }
          location.reload();
        } else {
          showError(validationObj);
        }
      };
      // END:
      // Utility + validation functions.

      // START:
      // UI functions.
      const updateForm = (user) => {
        if (!user || !user.dob) {
          return;
        }
        $province.prop('value', user.province);
        $date.prop('value', user.dob.dd);
        $month.prop('value', user.dob.mm);
        $year.prop('value', user.dob.yy);
        $remember.prop('checked', user.remember);
      };

      const updateAgeGateButton = (user) => {
        if (!user || user === null || !user.province) {
          return;
        }

        const $ageGateButton = $('.age-gate-button');
        const userProvince = user.province;
        const provincesObj = JSON.parse($ageGateButton.data('provinces').replace(/'/g, '"'));
        $ageGateButton.text(`${provincesObj[userProvince]}`);
      };

      const showError = (validationObj) => {
        if (!validationObj) {
          return;
        }
        if (!validationObj.valid && validationObj.reason) {
          $ageGateContent.addClass('d-none');
          $lockedOutWrapper.removeClass('d-none');
          if ('age' === validationObj.reason) {
            $lockedOutMsgAge.removeClass('d-none');
          } else if ('province' === validationObj.reason) {
            $lockedOutMsgProvince.removeClass('d-none');
          }
        }
      };

      const showContent = () => {
        $lockedOutWrapper.addClass('d-none');
        $lockedOutMsgAge.addClass('d-none');
        $lockedOutMsgProvince.addClass('d-none');
        $ageGateContent.removeClass('d-none');
      };
      // END:
      // UI functions.

      // Triggered functions:
      $ageGateBackBtn.on('click', () => {
        showContent();
      });

      $ageGateModal.on('submit', (evt) => {
        evt.preventDefault();
        handleSubmit();
      });

      if (!isUserValid() && !Shopify.designMode) {
        $ageGateModal.modal('show');
      }
    }
  });
})(jQuery);
